module.exports = __webpack_public_path__ + "static/media/Knight439_2c.11d06e81.svg";